@if (text) {
  @if (showEllipsis) {
    <span [ngClass]="textHiddenClass">
      <!-- Keep on one line: line breaks render as a space (preserveWhitespaces) -->
      {{ abbreviatedText }}@if (!hideButtons) {<small><button type="button" class="btn btn-link shadow-none" (click)="setShowEllipsis(false, $event)">...</button></small>}
    </span>
  } @else {
    <!-- Keep on one line: line breaks render as a space (preserveWhitespaces) -->
    <span [ngClass]="textUnhiddenClass">{{ text }}@if (!hideButtons) {<button type="button" class="btn btn-link shadow-none show-less" [ngClass]="showLessClass" (click)="setShowEllipsis(true, $event)">{{ 'Show less' | messageTranslate }}</button>}</span>
  }
}
